<script lang="ts">
  import { onMount } from "svelte"
  import { Layout } from "../../components"
  import { Code, Button } from "@gl/design-system"
  import { deleteCompositor, getCompositor } from "../../services/endpoints"
  import { navigateCustom, navigateCustomUrl } from "../../utils/navigateCustom"
  import { _ } from "svelte-i18n"

  export let uuid;
  
  let compositor: null | string = null;
  
  onMount(() => {
    getCompositor(uuid).then((com) => compositor = JSON.stringify(com, null, 2))
  })

  function del() {
    deleteCompositor(uuid).then(() => navigateCustom("/compositors")).catch(() => alert("Compositor maybe still in use by a location"))
  }
</script>

<Layout selected="compositors">
  <Button on:click={(e) => navigateCustom("/compositors/patch/" + uuid, e)}>{$_("common.update")}</Button>
  <Button status="error" on:click={() => del()}>{$_("common.delete")}</Button>
  {#if compositor}
  <Code>
    {compositor}
  </Code>
  {/if}
</Layout>